<template>
      <main>
          <loading-container :loading="loading" @loaded="init">
            <div class="body">
              <div class="content">
              <div class="column">
<!--                <h4>Код <img src="@/assets/icons/question.svg" alt=""></h4>-->
<!--                <div class="input-block">-->
<!--                  <input name="code" v-model="store.code" v-validate="'required'" data-vv-validate-on="blur" type="text">-->
<!--                  <span class="text-danger text-sm">{{ errors.first('code') }}</span>-->
<!--                </div>-->
                <h4>Вывеска</h4>
                <div class="input-block">
                  <input autocomplete="off" name="board" v-model="store.board" type="text">
                </div>
                <h4>Юр. Лицо</h4>
                <div class="input-block">
                  <app-select label="company_name" :options="options" :key="store.index" :value="store.entity" @input="store.entity = $event"/>
                  <span class="text-danger text-sm" v-if="entity_error">{{entity_error}}</span>
                </div>
                <h4>Контактное лицо</h4>
                <div class="input-block">
                  <input autocomplete="off" v-model="store.contact" type="text">
                </div>
                <h4>Дата открытия торговой точки</h4>
                <div class="input-block">
                  <date-picker v-model="store.date_open"></date-picker>
                  <br>
                  <span class="text-danger text-sm" v-if="date_error">{{date_error}}</span>
                </div>
                <h4>Площадь, м<sup>2</sup></h4>
                <div class="input-block">
                  <input autocomplete="off" v-model="store.area" type="text">
                </div>
                <h4>Описание</h4>
                <div class="input-block">
                  <textarea v-model="store.about" name="" id="" cols="30" rows="10"></textarea>
                </div>
              </div>
              <div class="column">
                <h4 class="add">Электронный адрес</h4>
                <div class="input-block">
                  <input autocomplete="off" name="email" v-model="store.email" v-validate="'email'" data-vv-validate-on="blur" type="text">
                  <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                </div>
                <h4 class="add">Фактический адрес <a href="#" @click="$refs.adr.open(getAddress(), 'legal', 'Фактический адрес')">Заполнить</a></h4>
                <div class="input-block">
                  <input autocomplete="off" name="address" disabled type="text" :value="getAddressString()">
                  <span class="text-danger text-sm" v-if="legal_address_error">{{legal_address_error}}</span>
                </div>
                <h4>Телефон</h4>
                <div class="input-block">
                  <input autocomplete="off" name="phone" v-model="store.phone" v-validate="'required'" id="phone-input" data-vv-validate-on="blur" type="text">
                  <span class="text-danger text-sm">{{ errors.first('phone') }}</span>
                </div>
                <h4>Сайт (если отличается от основного)</h4>
                <div class="input-block">
                  <input autocomplete="off" v-model="store.site" type="text">
                </div>
                <h4>Cпециализация</h4>
                <div class="input-block">
                  <app-select label="name" :options="specializations" :key="store.index" :value="store.specialization" @input="store.specialization = $event"/>
                </div>
                <h4 class="add">Расписание работы
<!--                  <a href="#">Заполнить</a>-->
                </h4>
                <div class="input-block">
                  <input autocomplete="off" name="timetable" v-model="store.timetable" v-validate="'required'" data-vv-validate-on="blur" type="text">
                  <span class="text-danger text-sm">{{ errors.first('timetable') }}</span>
                </div>
                <h4>Тип</h4>
                <div class="input-block">
                  <app-select label="name" :options="types" :key="store.index" :value="store.type" @input="store.type = $event"/>
                </div>
                <div class="btn">
                  <button @click="submit()">Сохранить</button>
                </div>
              </div>
              <adress-modal ref="adr" @save="adressSave"/>
              <div class="column cent">
                <div class="top__title-radio">
                  <div
                      class="top__title-radio-item"
                      v-for="(item) in tab"
                      :class="{active: store.active == item.key}"
                      :key="item.key"
                      @click="store.active = item.key"
                  >
                    {{item.title}}
                  </div>

                </div>
                <app-radio v-model="store.own" val="1">
                  Площадь арендуется
                </app-radio>
                <app-radio v-model="store.own" val="2">
                  Находится в собственности
                </app-radio>
                <app-checkbox v-model="store.eshop">Является точкой выдачи товара интернет магазина</app-checkbox>
              </div>
            </div>
            </div>
          </loading-container>
      </main>
</template>

<script>
    import AppSelect from "@/components/app-select";
    import Inputmask from 'inputmask'
    import AdressModal from "@/components/modals/adress-modal";
    import LoadingContainer from "@/components/loading-container";
    import AppCheckbox from "@/components/app-checkbox";
    import AppRadio from "@/components/app-radio";

    export default {
        name: "add-contragent",
        data: ()=>({
            options: [],
            specializations: [],
            types: [],
            tab: [
                { title: 'Работает', key: 1, },
                { title: 'Закрыто', key: 0, },
            ],
            sloading: true,
            loading: true,
            store: {
              selected: '0',
              active: 1,
              own: 1,
              code: '',
              board: '',
              entity: '',
              contact: '',
              date: '',
              area: '',
              about: '',
              phone: '',
              site: '',
              eshop: false,
              specialization: '',
              type: '',
              address: '',
              timetable: '',
              email: '',
              country: '',
              city: '',
              street: '',
              house: '',
              corps: '',
              flat: '',
              index: '',
              main: false,
              legal_address_country: null,
              legal_address_city : null,
              legal_address_region : null,
              legal_address_street : null,
              legal_address_house : null,
              legal_address_corps : null,
              legal_address_flat : null,
              legal_index : null,
              legal_info : null,
            },
            country_error: '',
            city_error: '',
            street_error: '',
            house_error: '',
            corps_error: '',
            flat_error: '',
            index_error: '',
            date_error: '',
            entity_error: '',
            legal_address_error: '',
            initialized: false,
            dirty: false,
            escape: true
        }),
        components: {
          AppRadio,
          AppCheckbox,
          LoadingContainer,
          AdressModal,
            AppSelect
        },
        beforeRouteLeave (to, from, next) {
            // If the form is dirty and the user did not confirm leave,
            // prevent losing unsaved changes by canceling navigation
            if (this.confirmStayInDirtyForm()){
                next(false)
            } else {
                // Navigate to next view
                next()
            }
        },
        created() {
            window.addEventListener('beforeunload', this.beforeWindowUnload)
        },
        beforeDestroy() {
            window.removeEventListener('beforeunload', this.beforeWindowUnload)
        },
        async mounted() {
          await this.getEntities ();
          await this.getTypes();
          await this.getSpecializations();
          if(this.$route.name == 'editStorePoint') {
            await this.getStore ();
          }else{
            this.loading = false;
            this.initialized = true;
          }
        },
        methods: {
          confirmLeave() {
            return window.confirm('Вы действительно хотите уйти? Несохраненные данные будут утеряны!')
          },

          confirmStayInDirtyForm() {
            return this.escape && this.dirty && !this.confirmLeave()
          },
          beforeWindowUnload(e) {
            if (this.confirmStayInDirtyForm()) {
              // Cancel the event
              e.preventDefault()
              // Chrome requires returnValue to be set
              e.returnValue = ''
            }
          },
          init(){
            var im = new Inputmask("+7(999) 999 99 99");
            im.mask(document.getElementById('phone-input'));
          },
          valid() {
            this.clearErrors()
            if (!this.store.date_open) {
              this.date_error = 'Поле обязательно к заполнению';
            }
            if (!this.store.entity) {
              this.entity_error = 'Поле обязательно к заполнению';
            }
            if (this.store.legal_address_country == null ||
                this.store.legal_address_city == null ||
                this.store.legal_address_street == null ||
                this.store.legal_address_house == null /*||
                this.store.legal_address_flat == null ||*/
                /*this.store.legal_index == null*/) {
              this.legal_address_error = 'Поле обязательно к заполнению';
            }

            return (!this.entity_error && !this.date_error && !this.legal_address_error)
          },
          getEntities() {
            if (localStorage.getItem('token')) {
              this.sloading = true;
              this.$http.post('/get-entities', {
                token: localStorage.getItem('token')
              })
                  .then(({data}) => {
                    if (data.entities) {
                      this.options = data.entities;
                    }
                  })
                  .catch((error) => {
                    console.log(error)
                  })
                  .finally(()=> this.sloading = false)
            }
          },
          getTypes() {
            if (localStorage.getItem('token')) {
              this.sloading = true;
              this.$http.post('/get-store-types', {
                token: localStorage.getItem('token')
              })
                .then(({data}) => {
                if (data.types) {
                  this.types = data.types;
                }
              })
              .catch((error) => {
                  console.log(error)
              })
              .finally(()=> this.sloading = false)
            }
          },
          getSpecializations() {
            if (localStorage.getItem('token')) {
              this.sloading = true;
              this.$http.post('/get-store-specializations', {
                token: localStorage.getItem('token')
              })
                .then(({data}) => {
                if (data.specializations) {
                  this.specializations = data.specializations;
                }
              })
              .catch((error) => {
                  console.log(error)
              })
              .finally(()=> this.sloading = false)
            }
          },
          getStore() {
            if (localStorage.getItem('token')) {
              this.loading = true;
              this.$http.post('/get-store', {
                token: localStorage.getItem('token'),
                id: this.$route.params.id
              })
                  .then(({data})=> {
                    if (data.store) {
                      this.store = data.store
                      this.store.specialization = data.store.store_specialization
                      this.store.type = data.store.store_type
                      this.store.entity = data.store.store_entity
                      this.$nextTick(() => {
                        this.initialized = true;
                      })
                    }
                  })
                  .catch((error) => {
                      console.log(error)
                  })
                .finally(()=> this.loading = false)
            }
          },
          submit() {
              this.$validator.validateAll().then(success => {
                if (this.valid() && success) {
                  this.loading = true;
                  let params = {
                    url: '/create-store',
                    msg: 'Данные успешно отправлены!',
                    query: {
                      token: localStorage.getItem('token'),
                      ...this.store,
                      entity: this.store.entity.id,
                      eshop: Number(this.store.eshop)
                    }
                  }
                  if(this.$route.name == 'editStorePoint'){
                    params.url = '/edit-store';
                    params.msg = 'Данные успешно изменены!';
                    params.query.id = this.$route.params.id
                  }
                  this.$http.post(params.url, params.query)
                      .then((response) => {
                        if (response.data.success) {
                          this.$toast.success(params.msg);
                          this.escape = false;
                          this.$router.push({name: 'storePoints'})
                        }else if(response.data.error_address){
                          this.$toast.error('Фактический адрес заполнен некорректно!');
                        }
                      })
                      .catch((error) => {
                        console.log(error)
                        this.$toast.error('Ошибка!');
                      })
                      .finally(()=> this.loading = false)
                }
              })
          },
          clearErrors(){
            this.date_error =  null
            this.entity_error = '';
            this.entity_error = '';
            this.legal_address_error = '';
          },
          getAddress(type = 'legal'){
            let adress_arr = {};
            adress_arr[type +'_address_country'] = this.store[type +'_address_country']
            adress_arr[type +'_address_city'] = this.store[type +'_address_city']
            adress_arr[type +'_address_region'] = this.store[type +'_address_region']
            adress_arr[type +'_address_street'] = this.store[type +'_address_street']
            adress_arr[type +'_address_house'] = this.store[type +'_address_house']
            adress_arr[type +'_address_corps'] = this.store[type +'_address_corps']
            adress_arr[type +'_address_flat'] = this.store[type +'_address_flat']
            adress_arr[type +'_index'] = this.store[type +'_index']
            adress_arr[type +'_info'] = this.store[type +'_info']
            return adress_arr;
          },
          getAddressString(type = 'legal'){
            if(this.store[type +'_address_country'] != null && this.store[type +'_address_city'] != null && this.store[type +'_address_house'] != null) {
              return `${this.store[type + '_index'] != null && this.store[type + '_index'] != '' ? (this.store[type + '_index'])+ ',' : ''} ${this.store[type + '_address_country'] != null && this.store[type + '_address_country'] != '' ? (this.store[type + '_address_country'])+ ',' : ''} ${this.store[type + '_address_city'] != null && this.store[type + '_address_city'] != '' ? (this.store[type + '_address_city'])+ ',' : ''} ${this.store[type + '_address_street'] != null && this.store[type + '_address_street'] != '' ? (this.store[type + '_address_street'])+ ',' : ''} ${this.store[type + '_address_house'] != null && this.store[type + '_address_house'] != '' ? (this.store[type + '_address_house'])+ ',' : ''} ${this.store[type + '_address_corps'] != null && this.store[type + '_address_corps'] != '' ? (this.store[type + '_address_corps'] + ',') : ''} ${this.store[type + '_address_flat'] != null && this.store[type + '_address_flat'] != '' ? this.store[type + '_address_flat'] : ''}`
            }else{
              return 'Не указано'
            }
          },
          adressSave(payload){
            Object.assign(this.store, payload)
          }
        },
        watch: {
          store:
          {
            handler()
            {
              if (this.initialized) {
                this.dirty = true;
              }

            },
            deep: true
          }
        }
    }
</script>

<style scoped lang="scss">

  .input-block {
    margin-bottom: 15px;
  }
  .cent{
    margin-top: 20px;
    padding-left: 10%;
    padding-right: 7%;
  }
  .btn{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    button{
      background: #2CB181;
      border-radius: 4px;
      height: 50px;
      width: 25%;
      border: none;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      color: #FFFFFF;
    }
  }
  .wrap{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
    .column-card{
      padding: 17px;
      width: 49.5%;
      background: #FFFFFF;
      box-shadow: 0px 0px 3px #E5E5EA;
      border-radius: 4px;
      margin-bottom: 17px;
      &.dis{
        opacity: 0.3;
      }
      .body{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 17px 0 10px 0;
        .item{
          text-align: left;
          p{
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #7A818F;
            margin: 5px 0;
            &.bold{
              color: #2D3137;
            }
          }
        }
        .status{
          text-align: right;
          p{
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 14px;
            color: #7A818F;
            margin-bottom: 5px;
            &.active{
              color: #2CB181;
            }
            &.base{
              color: #F39220;
            }
          }
        }
      }
      .top{
        padding: 0;
        margin: 0 -17px 0 -17px;
        border-bottom: 1px solid #D5D9E0;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: auto;
        h3{
          margin-top: -16px;
          margin-left: 17px;
          font-family: Roboto;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 19px;
          color: #2D3137;
        }
        .buttons {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: -16px;
          padding-right: 20px;
          button {
            height: 20px;
            border: none;
            background: none;
            cursor: pointer;
            outline: none;
            margin: 0 0 0 10px;
            > img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }

    }


  }

  main {
    padding: 30px;
    width: 85%;
  }
  h4{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #000000;
    margin: 0 0 5px 1px;
   &.add{
     display: flex;
     justify-content: space-between;
     a{
       font-family: Roboto;
       font-style: normal;
       font-weight: normal;
       font-size: 14px;
       line-height: 16px;
       text-align: right;
       text-decoration-line: underline;
       color: #7A818F;
     }
   }
  }
  .double{
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    .calendar{
      width: 49%;
    }
  }
  .right{
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    height: 100%;
    button{
      background: #2CB181;
      border-radius: 4px;
      height: 40px;
      width: 60%;
      margin-top: 600px;
      border: none;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      color: #FFFFFF;
    }
  }
  .body{
    .top{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 10px;
      &__title{
        display: flex;
        flex-wrap: wrap;
        .name{
          display: flex;
          align-items: center;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 19px;
          color: #2D3137;
          margin-right: 30px;
        }
        .status{
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 14px;
          color: #2CB181;
        }
        &-radio{
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 16px;
          display: flex;
          width: max-content;
          background-color: white;
          border-radius: 4px;
          border: 1px solid #EEF0F3;

          &-item {
            cursor: pointer;
            padding: 10px 15px;
            margin: 2px;
            color: #7A818F;
          }
          &-item.active {
            color: #2D3137;
            background: #EEF0F3;
            border-radius: 4px;
          }
        }
      }
    }
    .content{
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: space-between;
      width: 100%;
      img{
        margin: -5px 0;
      }
      input, textarea{
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 14px;
        color: #7A818F;
        padding: 10px;
        width: 100%;
        height: 40px;
        background: #FFFFFF;
        border: 1px solid #EEF0F3;
        box-sizing: border-box;
        border-radius: 4px;
        &.about{
          height: 107px;
        }
        &:disabled{
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 14px;
          color: #7A818F;
          background: #EEF0F3;
        }
      }
      .sec{
        margin-top: 126px;
      }
      .dis{
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #7A818F;
      }
      .btn{
        width: 100%;
        padding: 0;
        margin-top: 15px;
        button{
          width: 100%;
          height: 50px;
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #FFFFFF;
          background: #2CB181;
          border-radius: 4px;
          border: none;
        }
      }
      .password{
        position: relative;
        button{
          margin-top: 10px;
          width: 20px;
          height: 20px;
          position: absolute;
          right: 15px;
          top: 20%;
          transform: translateY(-50%);
          background-color: transparent;
          border: none;
          background-image: url('../../assets/img/main/eye.svg');
          background-position: center center;
          background-repeat: no-repeat;
          background-size: contain;
          cursor: pointer;

        }
      }
      .calendar{
        position: relative;
        button{
          margin-top: 10px;
          width: 20px;
          height: 20px;
          position: absolute;
          right: 15px;
          top: 20%;
          transform: translateY(-50%);
          background-color: transparent;
          border: none;
          background-image: url('../../assets/img/main/calendar.svg');
          background-position: center center;
          background-repeat: no-repeat;
          background-size: contain;
          cursor: pointer;

        }
      }
      .logo{
        height: 61px;
        background: #FFFFFF;
        box-shadow: 0px 0px 3px #E5E5EA;
        border-radius: 4px;
        margin-bottom: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 15px;
        button{
          background: #FFFFFF;
          width: 85%;
          height: 40px;
          border: 1px solid #B6BCC8;
          box-sizing: border-box;
          border-radius: 4px;
          font-style: normal;
          font-size: 12px;
          line-height: 14px;
          color: #7A818F;
          margin-left: 15px;
        }
        img{
          width: 44px;
          height: 44px;
        }
      }
    }

  }
  .column{
    width: 33%;
  }
  textarea {
    height: 116px !important;
  }


</style>
